<mat-card class="custom-card">
  <mat-card-title>{{ title }}</mat-card-title>
  <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
  <mat-card-content>
    <mat-expansion-panel expanded="{{ expanded }}" class="card-expansion-panel mat-elevation-z0">
      <mat-expansion-panel-header class="card-expansion-trigger"
        matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
      <div class="mt-2 mb-4">
        <button class="add-icon-button mr-2" color="primary" (click)="onAdd()" mat-flat-button
          matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above" *ngIf="!historical">
          <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'platformNotes.btnAdd' | translate }}
        </button>
      </div>
      <div class="table-wrapper">
        <div class="table-toolbar">
          <div class="row align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
            </div> <!-- /.col-12.col-md-4 -->
            <div class="col-12 col-sm-6 col-md-6 text-right">
              <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
                <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                {{ 'common.words.export' | translate }}
              </button>
              <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                {{ 'common.cta.resetFilters' | translate }}
              </button>
            </div> <!-- /.col-12.col-md-8 -->
          </div> <!-- /.row -->
        </div> <!-- /.table-toolbar -->
        <div class="spinner-container" *ngIf="dataSource.loading$ | async">
          <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
        </div> <!-- /.spinner-container -->
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="createdAt"
            matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ i + 1 }}
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md">
                {{ 'platformNotes.fields.category' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.category === 'subscription'">{{ 'platformNotes.categories.subscription' | translate }}</span>
                <span *ngIf="element.category === 'work-account'">{{ 'platformNotes.categories.work-account' | translate }}</span>
                <span *ngIf="element.category === 'technical-operational'">{{ 'platformNotes.categories.technical-operational' | translate }}</span>
                <span *ngIf="element.category === 'insertion'">{{ 'platformNotes.categories.insertion' | translate }}</span>
                <span *ngIf="element.category === 'mapping'">{{ 'platformNotes.categories.mapping' | translate }}</span>
                <span *ngIf="element.category === 'packaging'">{{ 'platformNotes.categories.packaging' | translate }}</span>
                <span *ngIf="element.category === 'tagnfc'">{{ 'platformNotes.categories.tagnfc' | translate }}</span>
                <span *ngIf="element.category === 'suppliers'">{{ 'platformNotes.categories.suppliers' | translate }}</span>
                <span *ngIf="element.category === 'other'">{{ 'platformNotes.categories.other' | translate }}</span>
              </td>
              <td mat-footer-cell *matFooterCellDef>
                <mat-form-field class="filter" >
                  <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                  <mat-select [formControl]="categoryFilter">
                    <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                    <mat-option value="subscription">{{ 'platformNotes.categories.subscription' | translate }}</mat-option>
                    <mat-option value="work-account">{{ 'platformNotes.categories.work-account' | translate }}</mat-option>
                    <mat-option value="technical-operational">{{ 'platformNotes.categories.technical-operational' | translate }}</mat-option>
                    <mat-option value="insertion">{{ 'platformNotes.categories.insertion' | translate }}</mat-option>
                    <mat-option value="mapping">{{ 'platformNotes.categories.mapping' | translate }}</mat-option>
                    <mat-option value="packaging">{{ 'platformNotes.categories.packaging' | translate }}</mat-option>
                    <mat-option value="tagnfc">{{ 'platformNotes.categories.tagnfc' | translate }}</mat-option>
                    <mat-option value="suppliers">{{ 'platformNotes.categories.suppliers' | translate }}</mat-option>
                    <mat-option value="other">{{ 'platformNotes.categories.other' | translate }}</mat-option>
                  </mat-select>
                  <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(categoryFilter)"
                    class="reset-input-icon ml-n3" *ngIf="categoryFilter.value"></mat-icon>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md">
                {{ 'platformNotes.fields.title' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.title }}</td>
              <td mat-footer-cell *matFooterCellDef>
                <mat-form-field class="filter" >
                  <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                  <input matInput [formControl]="titleFilter">
                  <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(titleFilter)"
                    class="reset-input-icon" *ngIf="titleFilter.value"></mat-icon>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                {{ 'platformNotes.fields.createdAt' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
              <td mat-footer-cell *matFooterCellDef>
                <mat-form-field class="filter" >
                  <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                  <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                    placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                    style="cursor: pointer" />
                  <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                    class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                  <mat-datepicker #dp></mat-datepicker>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md">
                {{ 'platformNotes.fields.createdBy' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.createdBy.firstName }} {{ element.createdBy.lastName }}
              </td>
              <td mat-footer-cell *matFooterCellDef>
                <mat-form-field class="filter" >
                  <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                  <input type="text" matInput [formControl]="createdByFilter" [matAutocomplete]="createdByAuto">

                  <mat-autocomplete autoActiveFirstOption #createdByAuto="matAutocomplete"
                    [displayWith]="displayCreatorFn.bind(this)"
                    (onSelectionChange)="onCreatorFilterSelected($event)">
                    <mat-option *ngIf="creatorsIsLoading" class="is-loading">
                      <mat-spinner diameter="50"></mat-spinner>
                    </mat-option>
                    <ng-container *ngIf="!creatorsIsLoading">
                      <mat-option *ngFor="let creator of availableCreatedBy" [value]="creator"
                        (onSelectionChange)="onCreatorFilterSelected($event)">
                        <small>{{ creator.firstName }} {{ creator.lastName }}</small>
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>

                  <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdByFilter)"
                    class="reset-input-icon" *ngIf="createdByFilter.value"></mat-icon>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="file">
              <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md">
                {{ 'platformNotes.fields.file' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <div *ngIf="element.file && element.file.path !== ''">
                  <a 
                    href="{{ configService.apiHost }}/{{ element.file.path }}" 
                    target="_blank" 
                    matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                  >
                    {{ element.file.originalName }}
                  </a>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef>
                
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-right pr-5"  class="col-fixed-xs">
                {{ 'common.cta.actions' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="text-right">
                <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                  matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                  {{ 'common.cta.open' | translate }}
                  <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                </button>
                <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                  <button mat-menu-item (click)="onView(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-eye"></mat-icon> 
                    {{ 'platformNotes.actions.view' | translate }}
                  </button>
                  <button mat-menu-item (click)="onEdit(element)" *ngIf="getEditEnabled(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-pencil"></mat-icon> 
                    {{ 'platformNotes.actions.edit' | translate }}
                  </button>

                  <a mat-menu-item routerLink="../../../companies/detail/{{element.companyId}}" *ngIf="getEditInCompany(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-arrow-alt-to-right"></mat-icon> 
                    {{ 'platformNotes.actions.edit' | translate }}
                  </a>

                  <button mat-menu-item (click)="onDeactivate(element)" *ngIf="deactivateEnable">
                    <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon> 
                    {{ 'platformNotes.actions.deactivate' | translate }}
                  </button>
                  <button mat-menu-item (click)="onDelete(element)" *ngIf="getEditEnabled(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-trash"></mat-icon> 
                    {{ 'platformNotes.actions.delete' | translate }}
                  </button>

                  <a mat-menu-item routerLink="../../../companies/detail/{{element.companyId}}" *ngIf="getEditInCompany(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-arrow-alt-to-right"></mat-icon> 
                    {{ 'platformNotes.actions.delete' | translate }}
                  </a>

                  <button mat-menu-item (click)="onAssociate(element)" *ngIf="getAssociateEnabled(element)">
                    <mat-icon fontSet="fal" fontIcon="fa-arrow-right" *ngIf="!isPoperty"></mat-icon> 
                    <mat-icon fontSet="fal" fontIcon="fa-euro-sign" *ngIf="isPoperty"></mat-icon> 
                    {{ 'platformNotes.actions.associate' | translate }}
                  </button>
                </mat-menu>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
             <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" [class.even-row]="(i % 2) == 0"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          </table>
          <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
            showFirstLastButtons></mat-paginator>
        </div> <!-- /.table-responsive -->
      </div> <!-- /.table-wrapper -->
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>